export default __webpack_public_path__ + "static/media/gradient background.6f2026db.jpg";